import Vue from "vue"
import Router from "vue-router"
import Meta from "vue-meta"

import routes from "./paths"
import store from "@/store"
import { isEmpty } from "lodash"

Vue.use(Router)
Vue.use(Meta)
const router = new Router({
  mode: "history",
  routes: routes
})

router.beforeEach((to, from, next) => {
  store.commit("loading-route-start")
  if (to.name === "Catalog" && isEmpty(store.state.catalogFilters.brand_id))
    store.commit("setCatalogFiltersValue", {
      attr: "brand_id",
      value: [store.state.globalBrand]
    })
  store.commit("clearDrawerFilters")
  next()
})
router.afterEach(() => {
  store.commit("loading-route-end")
})

export default router
